import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "flex flex-col w-full gap-4" };
const _hoisted_2 = { class: "flex flex-col justify-center h-full px-1 py-4 gap-y-2" };
const _hoisted_3 = ["innerHTML"];
import { computed } from "vue";
import { IconBuilding, IconBuildingBank, IconBell, IconCreditCard, IconKey, IconPalette, IconShieldCog, IconUserCircle, IconUsers, } from "@tabler/icons-vue";
import { useAbility, useAuthStore } from "@/domains/auth";
import { useFeatureFlagStore } from "@/domains/feature-flags";
import { FEATURE_FLAGS } from "@/constants/feature-flags";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SettingNavbar',
    setup(__props) {
        const { can } = useAbility();
        const authStore = useAuthStore();
        const featureFlagStore = useFeatureFlagStore();
        const allLinks = [
            {
                name: "Perfil personal",
                slug: "profile",
                link: "/admin/settings/profile",
            },
            {
                name: "Perfil de organización",
                slug: "organization_profile",
                link: "/admin/settings/organization-profile",
                orgProfileOnly: true,
            },
            {
                name: "Roles y permisos",
                slug: "roles_permissions",
                abilityCheck: { action: "read", subject: "Role" },
                link: "/admin/settings/roles",
            },
            {
                name: "Usuarios",
                slug: "users",
                abilityCheck: { action: "manage", subject: "OrganizationMember" },
                link: "/admin/settings/users",
            },
            {
                name: "Cuentas bancarias",
                slug: "bank_accounts",
                abilityCheck: { action: "manage", subject: "OrganizationBankAccount" },
                link: "/admin/settings/bank-accounts",
            },
            {
                name: "Claves del widget",
                slug: "widget_keys",
                abilityCheck: { action: "manage", subject: "Organization" },
                orgRequired: true,
                link: "/admin/settings/widget-keys",
            },
            {
                name: "Suscripción",
                slug: "subscription",
                abilityCheck: { action: "read", subject: "OrganizationBilling" },
                orgRequired: true,
                featureFlag: FEATURE_FLAGS.ORGANIZATION_BILLING,
                link: "/admin/settings/subscription",
            },
            {
                name: "Tema de marca",
                slug: "brand_theme",
                abilityCheck: { action: "read", subject: "Organization" },
                allowedOrgTypes: ["concierge"],
                link: "/admin/settings/brand-theme",
            },
            {
                name: "Notificaciones",
                slug: "notification_preferences",
                abilityCheck: { action: "manage", subject: "Notification" },
                featureFlag: FEATURE_FLAGS.NOTIFICATIONS,
                link: "/admin/settings/notification-preferences",
            },
            {
                name: "Entregas de notificaciones",
                slug: "notification_deliveries",
                abilityCheck: { action: "manage", subject: "Notification" },
                globalOnly: true,
                featureFlagGlobal: FEATURE_FLAGS.NOTIFICATIONS,
                link: "/admin/settings/notification-deliveries",
            },
            {
                name: "Tags",
                slug: "tags",
                abilityCheck: { action: "manage", subject: "Tag" },
                link: "/admin/settings/tag",
                icon: '<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-tag"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M7.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" /><path d="M3 6v5.172a2 2 0 0 0 .586 1.414l7.71 7.71a2.41 2.41 0 0 0 3.408 0l5.592 -5.592a2.41 2.41 0 0 0 0 -3.408l-7.71 -7.71a2 2 0 0 0 -1.414 -.586h-5.172a3 3 0 0 0 -3 3z" /></svg>',
            },
            {
                name: "Configuración general",
                slug: "general_configuration",
                abilityCheck: { action: "manage", subject: "System" },
                link: "/admin/settings/general-config",
                icon: '<svg class="w-6 h-6 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 15v3c0 .5523.44772 1 1 1h4v-4m-5 0v-4m0 4h5m-5-4V6c0-.55228.44772-1 1-1h16c.5523 0 1 .44772 1 1v1.98935M3 11h5v4m9.4708 4.1718-.8696-1.4388-2.8164-.235-2.573-4.2573 1.4873-2.8362 1.4441 2.3893c.3865.6396 1.2183.8447 1.8579.4582.6396-.3866.8447-1.2184.4582-1.858l-1.444-2.38925h3.1353l2.6101 4.27715-1.0713 2.5847.8695 1.4388"/></svg>',
            },
        ];
        const visibleLinks = computed(() => allLinks.filter((link) => {
            if ((link.slug === "profile" || link.hideForSuperAdminTenant) &&
                authStore.isSuperAdmin &&
                authStore.currentOrgId) {
                return false;
            }
            if (link.orgProfileOnly && !canAccessOrganizationProfile()) {
                return false;
            }
            if (link.globalOnly && !canAccessGlobalSettings()) {
                return false;
            }
            if (link.orgRequired && !authStore.currentOrgId) {
                return false;
            }
            if (link.featureFlag && !featureFlagStore.isRuntimeEnabled(link.featureFlag)) {
                return false;
            }
            if (link.featureFlagGlobal &&
                !featureFlagStore.isGlobalEnabled(link.featureFlagGlobal)) {
                return false;
            }
            if (link.allowedOrgTypes && !canAccessOrgType(link.allowedOrgTypes)) {
                return false;
            }
            if (!link.abilityCheck)
                return true;
            return can(link.abilityCheck.action, link.abilityCheck.subject);
        }));
        function canAccessOrgType(allowedOrgTypes) {
            if (!authStore.currentOrgId)
                return authStore.isSuperAdmin;
            if (!authStore.currentOrgType)
                return false;
            return allowedOrgTypes.includes(authStore.currentOrgType);
        }
        function canAccessOrganizationProfile() {
            const roleKey = authStore.primaryRole || "";
            if (!authStore.currentOrgId)
                return false;
            if (authStore.isSuperAdmin)
                return true;
            return (roleKey === "provider_owner" ||
                roleKey === "provider_admin" ||
                roleKey === "concierge_owner" ||
                roleKey === "concierge_admin");
        }
        function canAccessGlobalSettings() {
            return authStore.isSuperAdmin && !authStore.currentOrgId;
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleLinks.value, (link) => {
                        return (_openBlock(), _createBlock(_component_router_link, {
                            key: link.name,
                            class: _normalizeClass(["flex items-center w-full gap-2 p-3 tracking-wider cursor-pointer text-md text-ewhite-500",
                                _ctx.$route.path.includes(link.link)
                                    ? 'bg-ewhite-50 rounded-2xl border'
                                    : 'text-eblack-500 hover:bg-ewhite-100 rounded-lg'
                            ]),
                            to: link.link
                        }, {
                            default: _withCtx(() => [
                                _withDirectives(_createVNode(_unref(IconUserCircle), null, null, 512), [
                                    [_vShow, link.slug == 'profile']
                                ]),
                                _withDirectives(_createVNode(_unref(IconBuilding), null, null, 512), [
                                    [_vShow, link.slug == 'organization_profile']
                                ]),
                                _withDirectives(_createVNode(_unref(IconShieldCog), null, null, 512), [
                                    [_vShow, link.slug == 'roles_permissions']
                                ]),
                                _withDirectives(_createVNode(_unref(IconUsers), null, null, 512), [
                                    [_vShow, link.slug == 'users']
                                ]),
                                _withDirectives(_createVNode(_unref(IconBuildingBank), null, null, 512), [
                                    [_vShow, link.slug == 'bank_accounts']
                                ]),
                                _withDirectives(_createVNode(_unref(IconKey), null, null, 512), [
                                    [_vShow, link.slug == 'widget_keys']
                                ]),
                                _withDirectives(_createVNode(_unref(IconCreditCard), null, null, 512), [
                                    [_vShow, link.slug == 'subscription']
                                ]),
                                _withDirectives(_createVNode(_unref(IconPalette), null, null, 512), [
                                    [_vShow, link.slug == 'brand_theme']
                                ]),
                                _withDirectives(_createVNode(_unref(IconBell), null, null, 512), [
                                    [_vShow, link.slug == 'notification_preferences']
                                ]),
                                _withDirectives(_createVNode(_unref(IconBell), null, null, 512), [
                                    [_vShow, link.slug == 'notification_deliveries']
                                ]),
                                (link.icon)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        innerHTML: link.icon,
                                        class: "w-6 h-6"
                                    }, null, 8, _hoisted_3))
                                    : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(link.name), 1)
                            ]),
                            _: 2
                        }, 1032, ["class", "to"]));
                    }), 128))
                ])
            ]));
        };
    }
});
